import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';

import { TncComponent } from './pages/public/tnc/tnc.component';
import { AuthGuard } from './services/auth/auth-guard.service';


export const routes: Routes = [
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/public/auth/auth.module')
      .then(m => m.AuthModule),
  },
  {
    path: 'transaction-summary',
    loadChildren: () => import('./pages/public/transaction-summary/transaction-summary.module')
      .then(m => m.TransactionSummaryModule),
  },
  {
    path: 'invitation',
    loadChildren: () => import('./pages/public/invitation/invitation.module')
      .then(m => m.InvitationModule),
  },
  {
    path: 'transaction-summary',
    loadChildren: () => import('./pages/public/transaction-summary/transaction-summary.module')
      .then(m => m.TransactionSummaryModule),
  },
  {
    path: 'tnc',
    component: TncComponent,
  },
  {
    path: 'nbauth',
    component: NbAuthComponent,
    children: [
      {
        path: '',
        component: NbLoginComponent,
      },
      {
        path: 'login',
        component: NbLoginComponent,
      },
      {
        path: 'register',
        component: NbRegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
      },
    ],
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full', canActivate: [AuthGuard], },
  { path: '**', redirectTo: 'pages', canActivate: [AuthGuard], },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
